<section class="insured-object">

    <app-header-title title="Descrição do Objeto Segurado"
    subTitle="Selecione uma descrição para vincular a sua proposta." classTitle="insured-object__title-semibold--orange">
    </app-header-title>

    <form class="insured-object__select-area" [formGroup]="formGroup">
        <mat-label class="select-area__title">Descrição <mat-label class="select-area__mandatory">*</mat-label></mat-label>
        <mat-form-field appearance="outline" class="select-area__form-field">
          <mat-select placeholder="Selecione uma opção" formControlName="description" (selectionChange)="selectObjetoSegurado($event)" [disabled]="!listaObjetoSeguradoAtualizada.length || isRead">
            <mat-option *ngFor="let descricao of listaObjetoSeguradoAtualizada" [value]="descricao.id" [id]="descricao.textoObjetoSegurado">
                {{descricao.textoObjetoSegurado}}
            </mat-option>
          </mat-select>
          <mat-error>
            Descrição é <strong>obrigatório</strong>
          </mat-error>
        </mat-form-field>
    </form>

    <div class="insured-object__text-area">
        <p class="text-area__title">Confira o texto da descrição</p>
        <p class="text-area__text">{{insuredText}}</p>
    </div>

</section>
